import { render, staticRenderFns } from "./KeybeCopy.vue?vue&type=template&id=becd9d52&scoped=true&"
import script from "./KeybeCopy.vue?vue&type=script&lang=ts&"
export * from "./KeybeCopy.vue?vue&type=script&lang=ts&"
import style0 from "./KeybeCopy.vue?vue&type=style&index=0&id=becd9d52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becd9d52",
  null
  
)

export default component.exports